import { useEffect, useState } from "react";
import QRCode from "qrcode";
import { collection, deleteDoc, doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { createMirrorOffer, decodeMirrorDoc } from "../mirror";
import type { PairingPayload } from "../pairings";

/** Shows a QR the phone scans to mirror ALL its pairings into this browser (see mirror.ts). */
export function MirrorModal({ onClose, onMirrored }: { onClose: () => void; onMirrored: (ps: PairingPayload[]) => void }) {
  const [qrUrl, setQrUrl] = useState<string | null>(null);
  const [status, setStatus] = useState("Generating a secure code…");
  useEffect(() => {
    let alive = true;
    let unsub: (() => void) | undefined;
    void (async () => {
      const offer = await createMirrorOffer();
      const url = await QRCode.toDataURL(offer.qr, { width: 260, margin: 1 });
      if (!alive) return;
      setQrUrl(url);
      setStatus("Scan with your phone's camera — it opens Failover and mirrors all pairings here.");
      const ref = doc(collection(db, "keyMirror"), offer.relayId);
      unsub = onSnapshot(
        ref,
        (snap) => {
          const data = snap.data();
          if (!data) return; // not written yet
          void decodeMirrorDoc(offer, data).then((pairings) => {
            if (!pairings) {
              setStatus("Couldn't decrypt the mirror — regenerate and try again.");
              return;
            }
            void deleteDoc(ref).catch(() => {});
            onMirrored(pairings);
          });
        },
        (e) => setStatus(String(e)),
      );
    })();
    return () => {
      alive = false;
      unsub?.();
    };
  }, [onMirrored]);
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>Mirror from phone</h2>
        {qrUrl ? <img className="qr" src={qrUrl} alt="mirror code" /> : <div className="qr-ph" />}
        <p className="muted">{status}</p>
        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
}
